var _excluded = ["children", "className", "clickableAttribute", "disabled", "error", "inputRef", "inputWidth", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "optional", "supportiveText", "tooltip", "valid"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import LabeledField from "../LabeledField";
import Select from "../Select";
import { dataAndRest, specificDataAndRest } from "../../utils";
/**
 * Documentation:
 * 
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/dropdown)
 **/
var Dropdown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    clickableAttribute = _ref.clickableAttribute,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    inputRef = _ref.inputRef,
    _ref$inputWidth = _ref.inputWidth,
    inputWidth = _ref$inputWidth === void 0 ? 'default' : _ref$inputWidth,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    name = _ref.name,
    optional = _ref.optional,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    valid = _ref.valid,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _dataAndRest = dataAndRest(rest),
    _dataAndRest2 = _slicedToArray(_dataAndRest, 2),
    dataAttributes = _dataAndRest2[0],
    selectAttributes = _dataAndRest2[1];
  var _specificDataAndRest = specificDataAndRest(rest, clickableAttribute),
    _specificDataAndRest2 = _slicedToArray(_specificDataAndRest, 1),
    clickableAttributes = _specificDataAndRest2[0];
  return /*#__PURE__*/React.createElement(LabeledField, _extends({}, dataAttributes, {
    className: className,
    disabled: disabled,
    error: error,
    isAssertiveError: isAssertiveError,
    label: label,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    name: name,
    optional: optional,
    ref: ref,
    supportiveText: supportiveText,
    tooltip: tooltip
  }), /*#__PURE__*/React.createElement(Select, _extends({}, clickableAttributes, selectAttributes, {
    "aria-describedby": "".concat(name, "-error"),
    error: Boolean(error),
    id: name,
    name: name,
    inputRef: inputRef,
    required: !optional,
    valid: valid,
    width: inputWidth
  }), children));
});
Dropdown.displayName = 'Dropdown';
export default Dropdown;